import React from 'react';
import ReactEcharts from 'echarts-for-react';
import BaseComponent from "../../../base/BaseComponent";
import {Radio, DatePicker} from "antd";
import MyCard from "./MyCard";
const { RangePicker } = DatePicker;
let option = {
    tooltip: {
        trigger: 'item',
        formatter: "{b}: {c}"
    },
    grid: [{
        top: 50,
        width: '85%',
        bottom: '10%',
        left: '5%',
        containLabel: true
    }],
    xAxis: [{
        type: 'value',
        splitLine: {
            show: false
        },
        name:'单位：篇',
        nameLocation:'end',
        nameTextStyle:{
          padding: [30, 0, 0 ,50]
        },
        axisLine:{
            show: true,
            lineStyle: {
                type: 'solid',
                color:'#fff',
                width:'2'
            }
        },
        axisTick:{
            show: false
        }
    }],
    yAxis: [{
        splitLine: {
            show: true,
            lineStyle: {
                type: 'solid',
                color:'#fff',
                width:'2'
            }
        },
        data: ["已提交宣传部","已发布","已提交"],
        axisLine:{
            show: true,
            lineStyle: {
                color: '#fff'
            }
        },

        axisTick:{
            show: false
        }
    }],
    series: [{
        type: 'bar',
        barWidth: '45%',
        label: {
            normal: {
                show: true,
                position: "right",
                textStyle: {
                    color: "#555",
                    fontSize: 12
                }
            }
        },
        itemStyle: {
            normal: {
                color: '#1890ff',
                opacity: 1
            }
        },
        data: [100,64,20]
    }]
};
class StoryStatistics extends BaseComponent {

    static defaultProps = {};
    static propTypes = {};

    startTime = new Date().setHours(0,0,0,0);
    endTime = new Date().getTime();

    constructor(props) {
        super(props);
        this.state = {
            btnText: '今日',
            option : option
        }
    }

    componentDidMount() {
        // this.getStatisticsData()
    }

    rangePickerChange = (moment) => {
        this.startTime = moment[0]._d.setHours(0, 0, 0, 0);
        this.endTime = moment[1]._d.setHours(23, 59, 59);
        console.log("start:",new Date(this.startTime));
        console.log("end:",new Date(this.endTime));
        this.getStatisticsData();
    };

    handleSizeChange = e => {
        let data=e.target.value;
        let date = new Date();
        // 当前日
        let day = date.getDate();
        // 当前日是本周的第几天
        let dayOfWeek = date.getDay();
        let month = date.getMonth();
        let year = date.getFullYear();
        this.endTime = new Date().getTime();
        if(data === "今日"){
            this.startTime = date.setHours(0,0,0,0);
        }else if(data === "昨日"){
            let yesterday = new Date(year, month, day - 1);
            this.startTime = yesterday.setHours(0,0,0);
            this.endTime = yesterday.setHours(23,59,59);
        }else if(data === "本周"){
            this.startTime = new Date(year, month, day - dayOfWeek).setHours(0,0,0);
        }else if(data === "本月"){
            this.startTime = new Date(year, month, 1).setHours(0,0,0);
        }else if(data === "本年"){
            this.startTime = new Date(year, 1, 1).setHours(0,0,0);
        }
        this.setState({btnText: data});
        console.log("start:",new Date(this.startTime));
        console.log("end:",new Date(this.endTime));
        this.getStatisticsData();
    };

    render() {
        return (
            <MyCard title={'稿件统计'} className={'storyStatistics'}>
                <div style={{position:'relative'}}>
                    <div style={{height:300,width:'100%'}}>
                        <ReactEcharts
                            option={option}
                            notMerge={true}
                            lazyUpdate={true}
                            style={{width: '100%',height:'100%',  textAlign: 'center'}}
                        />
                    </div>

                    <div style={{height:32,position:'absolute',right:40,top:10}}>
                        <Radio.Group value={this.state.btnText} onChange={this.handleSizeChange}>
                            <Radio.Button value="今日">今日</Radio.Button>
                            <Radio.Button value="昨日">昨日</Radio.Button>
                            <Radio.Button value="本周">本周</Radio.Button>
                            <Radio.Button value="本月">本月</Radio.Button>
                            <Radio.Button value="本年">本年</Radio.Button>
                        </Radio.Group>
                        <RangePicker allowClear style={{width: 230,marginRight: 20}} onChange={this.rangePickerChange}/>
                    </div>
                </div>
                <style>
                    {
                        `.storyStatistics .ant-card-body{padding:0}`
                    }
                </style>
            </MyCard>
        );
    }

    getStatisticsData = () =>{
        let url = '';
        let params = {
            start: this.startTime,
            end: this.endTime
        };
        // this.request(url, () =>{
        //
        // },'json','get',params);
    };

    changeOption = (data) => {
        option.yAxis.data = [];
        option.series.data = [];
        this.setState({option: option})
    }
}

export default StoryStatistics;